module.exports = __webpack_public_path__ + "img/chase_slide_1.d2fa48da.jpg";